import { render, staticRenderFns } from "./VerifyBoxStart.vue?vue&type=template&id=7beb661e&lang=pug&"
import script from "./VerifyBoxStart.vue?vue&type=script&lang=js&"
export * from "./VerifyBoxStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports